import { CalendarEventResponseStatusEnum, EntitiesReportInput } from 'generated/graphql';

const baseFields = [
  { field: 'interact_id' },
  { field: 'custom_id' },
  { field: 'entity_type_name' },
  { field: 'date_added_to_campaign' },
  { field: 'name' },
  { field: 'nickname' },
  { field: 'preferred_language' },
  { field: 'emails', data: { count: 1, types: ['home', 'work'] } },
  { field: 'phone_numbers', data: { count: 1, types: ['home', 'work', 'cell'] } },
  { field: 'most_recent_assessment' }
];

/**
 * Gather the selected tag categories and add them as fields to the export
 * @returns Fields input for the calendar event responses export
 */
function buildCalendarEventResponseFields(selectedCategories) {
  const fields = [...baseFields, {
    field: 'calendar_event_tags',
    data: {
      tag_category_ids: selectedCategories.map(c => c.id),
    }
  }];

  return fields;
};

interface CalendarEventResponseExportOptions {
  campaignId: string;
  calendarEventIds: string[];
  selectedCategories: Array<{ id: string }>;
  rsvpStatuses: CalendarEventResponseStatusEnum[];
}

export function makeResponsesInput({
  campaignId,
  calendarEventIds,
  selectedCategories,
  rsvpStatuses
}: CalendarEventResponseExportOptions): EntitiesReportInput {
  const input = {
    params: {
      reportType: 'calendar_event_responses',
      campaignId,
      fields: buildCalendarEventResponseFields(selectedCategories),
      extraParams: {
        calendar_event_ids: calendarEventIds,
        statuses: rsvpStatuses,
        tagCategoryIds: selectedCategories.map(c => c.id),
      }
    }
  };

  return input;
};
